<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Partnership Program',
                    to: { path: '/partnership-program' },
                },
                {
                    text: form.id
                        ? 'Ubah Partnership Program'
                        : 'Tambah Partnership Program',
                },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{
                form.id
                    ? "Ubah Partnership Program"
                    : "Tambah Partnership Program"
            }}
        </h3>

        <v-form ref="form">
            <v-card flat>
                <v-card-title>
                    {{
                        form.id
                            ? "Ubah Partnership Program"
                            : "Tambah Partnership Program"
                    }}
                    <v-spacer></v-spacer>
                    <v-btn
                        depressed
                        rouded
                        small
                        class="pa-2"
                        height="33px"
                        color="#EC675E"
                        style="min-width: 0 !important"
                    >
                        <v-icon color="white" style="font-size: 20px">
                            mdi-delete-outline
                        </v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider />
                <v-card-text>
                    <template>
                        <div class="mb-2 mt-4">
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Nama Program *
                                    </v-list-item-title>

                                    <v-text-field
                                        placeholder="Nama Program"
                                        v-model="form.nama"
                                        outlined
                                        :rules="[
                                            (v) =>
                                                !!v ||
                                                'Nama program wajib diisi',
                                        ]"
                                        required
                                    />
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Partnership Owner *
                                    </v-list-item-title>

                                    <v-autocomplete
                                        placeholder="Pilih Owner"
                                        v-model="form.owner_id"
                                        :items="data_owner"
                                        outlined
                                        item-text="nama"
                                        item-value="id"
                                        :rules="[
                                            (v) => !!v || 'Owner wajib diisi',
                                        ]"
                                    ></v-autocomplete>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Paket *
                                    </v-list-item-title>

                                    <v-autocomplete
                                        placeholder="Pilih Paket"
                                        outlined
                                        class="pa-0"
                                        v-model="form.package_id"
                                        :items="data_package"
                                        item-text="name"
                                        item-value="id"
                                        :rules="[
                                            (v) => !!v || 'Paket wajib diisi',
                                        ]"
                                    ></v-autocomplete>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Deskripsi *
                                    </v-list-item-title>

                                    <v-text-field
                                        placeholder="Deskripsi"
                                        v-model="form.description"
                                        outlined
                                        maxlength="255"
                                        :rules="[
                                            (v) =>
                                                !!v || 'Deskripsi wajib diisi',
                                        ]"
                                    />
                                </v-list-item-content>
                            </v-list-item>
                        </div>
                        <v-row class="pa-4">
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                @click="$router.push('/partnership-program')"
                                class="mr-2"
                            >
                                Batal
                            </v-btn>

                            <v-btn
                                color="primary"
                                depressed
                                @click="submitProcess()"
                            >
                                Simpan
                            </v-btn>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>
        </v-form>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import axios from "axios";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            token: JSON.parse(localStorage.getItem("token")).value,
            isLoading: false,
            data: [],
            form: {
                id: null,
                name: null,
                description: null,
                data_partner: null,
                owner_id: null,
                package_id: null,
                description: null,
                package_id: null,
            },
            page: "form",
            user_groups: [],
            data_user_groups: [],
            data_partner: [],
            data_owner: [],
            rules: [(v) => !!v || "Field is required"],
            data_package: null,
        };
    },

    watch: {},

    mounted: function () {
        this.fetchData();
        this.getUserGroupData();
        this.getPartner();
        this.getOwner();
        this.getPackage();
    },

    methods: {
        fetchData() {
            const context = this;
            const id = this.$route.query.id;
            const url = `${process.env.API_BASE_URL}partnership/admin/program/detail/${id}`;

            const authToken = this.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.form = response.data;
                    context.form.owner_id = response.data.data_owner.id;
                    context.form.name = response.data.name;
                }
            });
        },
        getPartner() {
            this.user_groups = [];
            const url =
                process.env.API_BASE_URL +
                "partnership/admin/partners?page=1&size=150";

            const authToken = this.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };
            const context = this;
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data_partner = response.data.list_partner;
                }
            });
        },
        getOwner() {
            this.user_groups = [];
            const url =
                process.env.API_BASE_URL +
                "partnership/admin/owners?page=0&size=150";

            const authToken = this.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };
            const context = this;
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data_owner = response.data.list_owner;
                }
            });
        },
        getUserGroupData() {
            this.user_groups = [];
            const url =
                process.env.API_BASE_URL +
                "/payment/list/user_group?page=1&per_page=150";

            const authToken = this.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };
            const context = this;
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data_user_groups = response.data.user_groups;
                }
            });
        },
        getPackage() {
            const context = this;
            const url = `${process.env.API_BASE_URL}payment/package/getallpackage`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data_package = response.data;
                }
            });
        },
        submitProcess() {
            const context = this;
            const id = this.$route.query.id;
            var url = "";

            if (id) {
                url = `${process.env.API_BASE_URL}partnership/admin/program/${id}`;
            } else {
                url = `${process.env.API_BASE_URL}partnership/admin/program/register`;
            }

            const authToken = this.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            if (context.$refs.form.validate()) {
                if (!id) {
                    try {
                        axios
                            .post(url, context.form, options)
                            .then(function (response) {
                                if (response.status === 200) {
                                    context.$store.commit("showAlert", {
                                        message: `Berhasil menambahkan partnership program`,
                                        type: "success",
                                    });

                                    context.$router.push(
                                        "/partnership-program",
                                    );
                                }
                            });
                    } catch (err) {
                        context.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan`,
                            submessage: `Tidak dapat menambahkan partnership program untuk saat ini`,
                            type: "error",
                        });
                    }
                } else {
                    try {
                        axios
                            .put(url, context.form, options)
                            .then(function (response) {
                                if (response.status === 200) {
                                    context.$store.commit("showAlert", {
                                        message: `Berhasil mengubah partnership program`,
                                        type: "success",
                                    });

                                    context.$router.push(
                                        "/partnership-program",
                                    );
                                }
                            });
                    } catch (err) {
                        context.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan`,
                            submessage: `Tidak dapat mengubah partnership program untuk saat ini`,
                            type: "error",
                        });
                    }
                }
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// PartnershipProgramForm.vue?4ac6bf05